(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Checkout = window.JVZoo.Checkout || {};
    var checkout = window.JVZoo.Checkout;
    var whopCheckout = checkout.Whop = checkout.Whop || {};
    var selectors = checkout.JquerySelectors || {};
    whopCheckout.isElementsCheckout = true;

    // Endpoints
    const RENDER_CHECKOUT_SESSION_URI = '/paypal/whopRenderCheckoutSession';
    const CREATE_PAYMENT_URI = '/paypal/whopCreatePayment';
    const FINALIZATION_STATUS_CHECK_URI = '/paypal/whopFinalizationStatus';
    const DUPLICATE_CHECK_URI = '/paypal/checkPreviousPurchase';

    // Elements rendered by cc_whop_embedded.twig and whop_purchase_success.twig
    const WHOP_WRAPPER_SELECTOR = '#whop-iframe-wrapper';
    const WHOP_BUTTON_SELECTOR = '#whopPayButton';
    const WHOP_MESSAGE_SELECTOR = '#whop-elements-message';
    const WHOP_CONTINUE_PAYMENT_SELECTOR = '#whop-continue-payment';
    const WHOP_ELEMENT_CONTAINER_SELECTOR = '#whop-iframe-container';
    const WHOP_VERIFYING_OVERLAY_ID = 'whop-verifying-overlay';
    const WHOP_VERIFYING_OVERLAY_TEXT_SELECTOR = '.whop-verifying-overlay__text';
    const WHOP_PAYMENT_ELEMENT_SELECTOR = '#whop-payment-element';
    const WHOP_BRANDING_ELEMENT_SELECTOR = '#whop-branding-element';
    const WHOP_PROCESSING_SELECTOR = '#whop-processing-screen';
    const WHOP_PROCESSING_TEXT_SELECTOR = '.text';
    const WHOP_CREDIT_CARD_INFO_SELECTOR = '#cc-info-section';
    const WHOP_INLINE_MESSAGE_ID = 'whop-inline-message';
    const WHOP_RETURN_PAGE_SELECTOR = '[data-whop-elements-return]';
    const WHOP_SAME_AS_SHIPPING_SELECTOR = '#same-as-shipping-checkbox';
    // Express wallet row (whop_express_button.twig) and the buttons jvzoo.checkout.whop.express.js draws in it,
    // which manages their disabled state itself.
    const WHOP_EXPRESS_ROW_SELECTOR = '#whop-express-row';
    // Set by jvzoo.checkout.whop.express.js while at least one wallet button shows.
    const WHOP_EXPRESS_ROW_VISIBLE_CLASS = 'is-wallet-visible';
    // Message line under the wallet buttons, used while the Whop card section is hidden.
    const WHOP_EXPRESS_MESSAGE_SELECTOR = '#whop-express-message';
    // Second Continue Payment Verification button, under the express line, for when the card section is hidden.
    const WHOP_EXPRESS_CONTINUE_SELECTOR = '#whop-express-continue';
    const WHOP_EXPRESS_MESSAGE_ERROR_CLASS = 'is-error';
    // Errors on the express line use the same Bootstrap alert as the card section's error box (INLINE_ERROR_CLASS).
    const WHOP_EXPRESS_MESSAGE_ALERT_CLASSES = ['alert', 'alert-danger'];
    // Page class while a wallet charge is in progress; it locks the other processors' own buttons (e.g. the PayPal
    // smart button iframe, which freezeOrderControls cannot disable).
    const WHOP_EXPRESS_PAYING_CLASS = 'whop-express-paying';
    const WHOP_EXPRESS_BUTTON_SELECTOR = '.whop-express-wallet-button';
    /** Keep synchronized with \Paypal::WHOP_CHECKOUT_SESSION_KEY_FIELD_NAME */
    const WHOP_CHECKOUT_SESSION_KEY_FIELD_NAME = 'whop_checkout_session_key';
    /** Keep synchronized with \Paypal::CUSTOMER_COUNTRY_ID */
    const CUSTOMER_COUNTRY_ID_PARAM = 'customer_country_id';
    const WHOP_SESSION_FIELD_SELECTOR = '#' + WHOP_CHECKOUT_SESSION_KEY_FIELD_NAME;
    const DUPLICATE_PURCHASE_MODAL_SELECTOR = '#emailModalWhop';
    const DUPLICATE_PURCHASE_MODAL_LIST_SELECTOR = DUPLICATE_PURCHASE_MODAL_SELECTOR + ' .modal-body section';
    const OPTOUT_SELECTOR = '#optout';
    const FORM_CONTROLS_SELECTOR = 'input, select, textarea, button';

    // Order bumps and the price summary the server reprices
    const ORDER_BUMP_INPUT_SELECTOR = 'input[name="bumpOrder[]"]';
    const ORDER_BUMPS_SELECTOR = '#order_bumps';
    const ORDER_BUMP_ITEM_SELECTOR = '.order_overview-item';
    const ORDER_BUMP_PRICE_SELECTOR = '.order_bump-price';
    const ORDER_BUMP_RECURRING_SELECTOR = '.order-bump-recurring-info p.text-muted';
    const ORDER_BUMP_SUMMARY_ROW_SELECTOR = '.order-bump-summary-row';
    const ORDER_BUMP_SUMMARY_PRICE_SELECTOR = '.price-value';
    const VAT_INFO_SELECTOR = '#vat-info';
    const VAT_AMOUNT_SELECTOR = '#vat-amount-display';
    const TOTAL_WITH_VAT_SELECTOR = '#total-with-vat-display';
    const RECURRING_CONSENT_TEXT_SELECTOR = '.recurring-consent-text';
    const COUPON_ERROR_SELECTOR = '#coupon_code_error';
    const COUPON_DISCOUNT_ROW_SELECTOR = '#coupon-discount-price-row';
    const COUPON_DISCOUNT_VALUE_SELECTOR = '#coupon-discount-value';
    const COUPON_LABEL_SELECTOR = '#coupon-label-text';
    const NORMALLY_PRICE_ROW_SELECTOR = '#normally-price-row';
    const CART_SUMMARY_TITLE_SELECTOR = '#cart-summary-title';

    // Data attributes
    const DATA_CHECKOUT_CONTEXT_KEY = 'data-checkout-context-key';
    const DATA_JVZOO_CHECKOUT_KEY = 'data-jvzoo-checkout-key';
    const DATA_REGISTRATION_KEY = 'data-registration-key';
    const DATA_WHOP_ENVIRONMENT = 'data-whop-environment';
    const DATA_SESSION_EXPIRY_ENABLED = 'data-session-expiry-enabled';
    const DATA_SESSION_EXPIRY_DAYS = 'data-session-expiry-days';
    const DATA_HAS_TRIAL = 'data-has-trial';
    const DATA_ORDER_BUMP_ID = 'data-ob-id';

    // Request parameters read by the Whop actions in Paypal.php
    /** Keep synchronized with WhopElementsConstants::CHECKOUT_CONTEXT_KEY, REGISTRATION_KEY and JVZOO_CHECKOUT_KEY */
    const CHECKOUT_CONTEXT_KEY_PARAM = 'checkout_context_key';
    const REGISTRATION_KEY_PARAM = 'registration_key';
    const JVZOO_CHECKOUT_KEY_PARAM = 'jvzoo_checkout_key';
    /** Keep synchronized with \Paypal::WHOP_CONFIRMATION_TOKEN_FIELD_NAME */
    const CONFIRMATION_TOKEN_PARAM = 'confirmationToken';
    /** Keep synchronized with \Paypal::WHOP_USE_ELEMENTS_FIELD_NAME */
    const USE_ELEMENTS_PARAM = 'useElements';
    // Read by Paypal::checkPreviousPurchase
    const DUPLICATE_CHECK_EMAIL_PARAM = 'customerEmail';
    const DUPLICATE_CHECK_NAME_PARAM = 'name';
    const DUPLICATE_CHECK_PRODUCT_IDS_PARAM = 'productIds';
    const FIELD_CHECKED_VALUE = '1';
    const FIELD_UNCHECKED_VALUE = '0';

    // Statuses returned by whopCreatePayment, whopFinalizationStatus and the Elements SDK. Keep synchronized with
    // WhopElementsConstants::STATUS_*, WhopPaymentStatusConstants and WhopSetupIntentStatusTypes.
    const STATUS_COMPLETED = 'completed';
    const STATUS_NOT_STARTED = 'not_started';
    const STATUS_PAID = 'paid';
    const STATUS_SUCCEEDED = 'succeeded';
    const STATUS_FAILED = 'failed';
    const STATUS_CANCELED = 'canceled';
    const STATUS_CANCELLED = 'cancelled';
    const STATUS_INVALID_SESSION = 'invalid_session';
    const STATUS_NEEDS_REVIEW = 'needs_review';
    const STATUS_BLOCKED = 'blocked';
    const STATUS_REQUIRES_ACTION = 'requires_action';
    const VERIFICATION_FAILED_STATUSES = [STATUS_FAILED, STATUS_CANCELED, STATUS_CANCELLED];
    const STOPPED_STATUSES = VERIFICATION_FAILED_STATUSES.concat([STATUS_INVALID_SESSION, STATUS_NEEDS_REVIEW]);
    // Rejection code when the buyer closes a wallet sheet; a cancel, not a payment error.
    const PAYMENT_REQUEST_CANCELLED = 'payment_request_cancelled';
    // Token sources for submitWithToken.
    const TOKEN_SOURCE_PAYMENT_ELEMENT = 'payment_element';
    const TOKEN_SOURCE_EXPRESS = 'express';

    // Whop Elements options
    /** Keep synchronized with WhopElementsConstants::MODE_PAYMENT and WhopElementsConstants::MODE_SETUP */
    const MODE_PAYMENT = 'payment';
    const MODE_SETUP = 'setup';
    const PAYMENT_ELEMENT_TYPE = 'payment';
    const BRANDING_ELEMENT_TYPE = 'branding';
    const SETUP_FUTURE_USAGE = 'off_session';
    const BILLING_DETAILS_HIDDEN = 'never';
    const BILLING_DETAILS_MINIMAL = 'minimal';
    const WALLET_DISABLED = 'never';
    const WALLET_AUTO = 'auto';
    const DEFAULT_WHOP_ENVIRONMENT = 'production';

    // Classes
    const MESSAGE_CLASS = 'mt-2';
    const ERROR_MESSAGE_CLASS = 'text-danger mt-2';
    const INLINE_ERROR_CLASS = 'alert alert-danger mt-2';
    const PROCESSING_ACTIVE_CLASS = 'active';
    const OVERLAY_READY_CLASS = 'whop-iframe-wrapper--overlay-ready';
    const OVERLAY_ACTIVE_CLASS = 'active';
    const INVALID_FIELD_CLASS = 'is-invalid';

    // Storage, timing and polling
    const PENDING_PAYMENT_STORAGE_PREFIX = 'jvz-whop-elements:';
    const DEFAULT_REQUEST_TIMEOUT_MS = 15000;
    const CREATE_PAYMENT_TIMEOUT_MS = 45000;
    const DUPLICATE_CHECK_TIMEOUT_MS = 10000;
    const ELEMENT_READY_TIMEOUT_MS = 10000;
    const RENDER_DEBOUNCE_MS = 300;
    // Whop quotes allowed per page load for the express wallets while another payment method is selected. Each quote
    // creates a registration, and the server caps them per checkout (WhopElementsConstants::MAX_REGISTRATIONS_PER_CONTEXT
    // = 25), so this leaves the rest for the card form if the buyer switches back.
    const MAX_OTHER_METHOD_QUOTES = 10;
    const CLIENT_LOAD_CHECK_INTERVAL_MS = 100;
    const MAX_CLIENT_LOAD_CHECKS = 100;
    const MAX_POLL_ATTEMPTS = 100;
    const POLL_INTERVAL_MS = 3000;
    const MAX_POLL_INTERVAL_MS = 15000;
    const POLLS_PER_BACKOFF_STEP = 5;
    const MILLISECONDS_PER_SECOND = 1000;
    const MAX_RETRY_TIMER_DELAY_MS = 60000;
    const INLINE_ERROR_FADE_IN_MS = 350;
    const INLINE_ERROR_SCROLL_MS = 500;
    const INLINE_ERROR_SCROLL_OFFSET = 10;

    // Messages
    const COMPLETING_ORDER_MESSAGE = 'Completing your order...';

    var _whopElements = null;
    var _whopElementsPayments = null;
    var _paymentElement = null;
    var _whopElementsIdentity = null;
    var _whopElementsReady = false;
    var _whopElementsComplete = false;
    var _elementGeneration = 0;
    var _renderSequence = 0;
    var _renderInProgress = false;
    var _sessionDirty = false;
    var _sessionExpired = false;
    var _sessionKey = null;
    var _jvzooCheckoutKey = null;
    var _registrationKey = null;
    var _pendingContextKey = null;
    var _returnUrl = null;
    var _submitting = false;
    var _chargeSubmitted = false;
    var _statusBusy = false;
    var _actionInFlight = false;
    var _clientSecret = null;
    var _paymentActionShown = false;
    var _actionAttempted = false;
    var _lastPaymentErrorMessage = null;
    var _retryNotBefore = 0;
    var _retryTimer = null;
    var _pollTimer = null;
    var _pollCount = 0;
    var _renderTimer = null;
    var _readyTimer = null;
    // Watches the hidden card section so the Payment Element ready check starts when it opens.
    var _sectionObserver = null;
    // Set when that check restarts after the section opened: one re-mount is allowed before the error shows.
    var _revealRetry = false;
    // Last successful quote, for a re-mount without another server call.
    var _lastQuote = null;
    var _initialized = false;
    var _couponRemoved = false;
    var _hasPurchasedTrialProducts = false;
    var _frozenControls = [];
    var _currencySymbol = '$';
    // Wallet types the express row shows, and the ones the device supports per Whop's last answer; null until known.
    var _expressWallets = null;
    var _expressAvailableWallets = null;
    var _expressSubmit = false;
    // An error on the express line stays until the buyer acts (pays again, changes the order or the payment method).
    var _expressErrorShown = false;
    var _otherMethodQuotes = 0;
    // Pricing from the latest express-only quote, applied to the page when the buyer returns to the Whop method.
    var _deferredWhopPricing = null;
    var _isReturnPage = !!find(WHOP_RETURN_PAGE_SELECTOR);

    function setChargeSubmitted(submitted) {
        // The checkout timer reads the flag so it never redirects while a payment is in progress.
        _chargeSubmitted = submitted;
        whopCheckout.isPaymentInProgress = submitted;
    }
    function find(selector) { return selector ? document.querySelector(selector) : null; }
    function value(selector) { var field = find(selector); return field ? (field.value || '').trim() : ''; }
    function wrapper() { return find(WHOP_WRAPPER_SELECTOR); }
    function postedOrderFormCountry() {
        // A submit of the order form sends every enabled control with this name, and PHP keeps the last.
        var form = find(selectors.orderFormById);
        if (!form) return '';
        var posted = '';
        Array.prototype.forEach.call(form.elements, function(control) {
            if (control.name !== CUSTOMER_COUNTRY_ID_PARAM || control.matches(':disabled')) return;
            posted = (control.value || '').trim();
        });
        return posted;
    }
    function appendField(data, selector, fieldValue) {
        // Posts under the field's own name so the order form stays the single definition.
        var field = find(selector);
        if (field && field.name) data.append(field.name, fieldValue === undefined ? (field.value || '').trim() : fieldValue);
    }
    function appendCheckbox(data, selector) {
        var checkbox = find(selector);
        if (checkbox) appendField(data, selector, checkbox.checked ? FIELD_CHECKED_VALUE : FIELD_UNCHECKED_VALUE);
    }
    function setText(selector, text) {
        if (!selector) return;
        document.querySelectorAll(selector).forEach(function(element) { element.textContent = text; });
    }
    function show(selector, visible, display) {
        var element = find(selector);
        if (element) element.style.display = visible ? (display || '') : 'none';
    }
    function isSessionLocked() {
        return _sessionExpired || !!(checkout.Session && checkout.Session.isLocked());
    }
    function isRetryCoolingDown() { return Date.now() < _retryNotBefore; }
    function isSessionBlocked() {
        // Shared by the card button and the express wallet buttons. The wallets pay from the Whop session alone; only
        // the card button also needs the Payment Element ready with complete card fields.
        return isSessionLocked() || isRetryCoolingDown() || _submitting || _chargeSubmitted
            || _sessionDirty || _renderInProgress || !_registrationKey || !_jvzooCheckoutKey;
    }
    function updatePayButton() {
        var blocked = isSessionBlocked();
        var button = find(WHOP_BUTTON_SELECTOR);
        if (button) button.disabled = blocked || !_whopElementsReady || !_whopElementsComplete;
        if (checkout.WhopExpress && checkout.WhopExpress.onStateChange) checkout.WhopExpress.onStateChange({canPay: !blocked});
        if (document.body) {
            document.body.classList.toggle(WHOP_EXPRESS_PAYING_CLASS, (_submitting && _expressSubmit) || _chargeSubmitted);
        }
        // The express Continue button stands in for the card section's one only while that section is hidden.
        var expressAction = find(WHOP_EXPRESS_CONTINUE_SELECTOR);
        if (expressAction) expressAction.hidden = !(_paymentActionShown && useExpressMessage());
    }
    function notifyExpressSession(data) {
        if (!checkout.WhopExpress || !checkout.WhopExpress.onSession) return;
        var pricing = data.pricing || {};
        var bumps = [];
        document.querySelectorAll(ORDER_BUMP_INPUT_SELECTOR + ':checked').forEach(function(input) {
            var price = pricing.bumpPrices ? parseFloat(pricing.bumpPrices[input.value]) : NaN;
            bumps.push({id: input.value, amountMinor: isNaN(price) ? null : Math.round(price * 100)});
        });
        checkout.WhopExpress.onSession({
            accountId: data.whopCompanyKey,
            currency: data.currency,
            amountMinor: data.amountMinor,
            isSetupMode: !!data.isSetupMode,
            requiresFutureUsage: !!data.isSetupMode || data.requiresFutureUsage !== false,
            paymentMethodConfiguration: data.paymentMethodConfiguration || null,
            bumps: bumps
        });
    }
    function isExpressActive() {
        // The express row is on the page and its module loaded. It pays from this Whop session whichever payment
        // method is selected, so the session stays live while another processor is selected.
        return !!(checkout.WhopExpress && find(WHOP_EXPRESS_ROW_SELECTOR));
    }
    function paymentElementWallets() {
        var wallets = {googlePay: WALLET_DISABLED, payPal: WALLET_DISABLED};
        // Apple Pay is offered once: in the express row while it shows an Apple Pay button (or is still checking),
        // otherwise here.
        // Sent explicitly either way, so turning it back on works whether update() merges or replaces.
        wallets.applePay = isExpressActive() && (_expressWallets === null || _expressWallets.indexOf('apple_pay') !== -1)
            ? WALLET_DISABLED : WALLET_AUTO;
        return wallets;
    }
    function isOtherMethodSelected() {
        return !!(checkout.getIsUsingWhop && !checkout.getIsUsingWhop());
    }
    function canQuoteForExpress() {
        // While another method is selected the Whop session is kept current only for wallet buttons on screen (or
        // still being checked), within the per-page budget.
        // A failed or paused quote hides the buttons but does not change what the device supports, so the next order
        // change can bring them back.
        return isExpressActive() && (_expressAvailableWallets === null || _expressAvailableWallets.length > 0)
            && _otherMethodQuotes < MAX_OTHER_METHOD_QUOTES;
    }
    function pauseExpressForOtherMethod() {
        // The Whop quote stays out of date until the buyer returns to the Whop method; the wallets hide meanwhile.
        _sessionDirty = true;
        _renderSequence++;
        clearTimeout(_renderTimer);
        clearTimeout(_readyTimer);
        _renderTimer = null;
        _renderInProgress = false;
        setVerifyingOverlay(false);
        notifyExpressSessionCleared();
        updatePayButton();
    }
    function notifyExpressSessionCleared() {
        if (checkout.WhopExpress && checkout.WhopExpress.onSessionCleared) checkout.WhopExpress.onSessionCleared();
    }
    function updateRetryCooldown() {
        clearTimeout(_retryTimer);
        _retryTimer = null;
        updatePayButton();
        var remaining = _retryNotBefore - Date.now();
        if (remaining > 0) _retryTimer = setTimeout(updateRetryCooldown, Math.min(remaining, MAX_RETRY_TIMER_DELAY_MS));
    }
    function ensureInlineError() {
        // Alert box at the top of the card section, as on the legacy embed.
        var inlineError = document.getElementById(WHOP_INLINE_MESSAGE_ID);
        var section = find(WHOP_CREDIT_CARD_INFO_SELECTOR);
        if (!inlineError && section) {
            inlineError = document.createElement('div');
            inlineError.id = WHOP_INLINE_MESSAGE_ID;
            inlineError.className = INLINE_ERROR_CLASS;
            inlineError.setAttribute('role', 'alert');
            inlineError.style.display = 'none';
            section.insertBefore(inlineError, section.firstChild);
        }
        return inlineError;
    }
    function showInlineError(text) {
        var inlineError = ensureInlineError();
        if (!inlineError) return false;
        var $inlineError = $(inlineError);
        $inlineError.stop(true, true);
        inlineError.textContent = text;
        inlineError.style.display = 'none';
        $inlineError.fadeIn(INLINE_ERROR_FADE_IN_MS);
        $('html, body').animate({scrollTop: $inlineError.offset().top - INLINE_ERROR_SCROLL_OFFSET},
            INLINE_ERROR_SCROLL_MS, 'linear');
        return true;
    }
    function clearInlineError() {
        // The session expiry message owns the alert box until the buyer refreshes.
        var inlineError = document.getElementById(WHOP_INLINE_MESSAGE_ID);
        if (!isSessionLocked()) setExpressMessage('');
        if (!inlineError || isSessionLocked()) return;
        $(inlineError).stop(true, true);
        inlineError.textContent = '';
        inlineError.style.display = 'none';
    }
    function setProcessingScreen(visible, text) {
        // The return page drives the same screen from showMessage.
        var processing = find(WHOP_PROCESSING_SELECTOR);
        if (!processing || _isReturnPage) return;
        var processingText = processing.querySelector(WHOP_PROCESSING_TEXT_SELECTOR);
        if (processingText && text) processingText.textContent = text;
        processing.classList.toggle(PROCESSING_ACTIVE_CLASS, !!visible);
    }
    function ensureVerifyingOverlay() {
        // Spinner over the payment element, as the legacy embed showed over its iframe.
        var container = find(WHOP_ELEMENT_CONTAINER_SELECTOR);
        if (!container) return null;
        container.classList.add(OVERLAY_READY_CLASS);
        var overlay = document.getElementById(WHOP_VERIFYING_OVERLAY_ID);
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = WHOP_VERIFYING_OVERLAY_ID;
            overlay.className = 'whop-verifying-overlay';
            overlay.setAttribute('aria-live', 'polite');
            overlay.innerHTML = '<div class="whop-verifying-overlay__panel">'
                + '<span class="whop-verifying-overlay__spinner" aria-hidden="true"></span>'
                + '<span class="whop-verifying-overlay__text"></span>'
                + '</div>';
            container.appendChild(overlay);
        }
        return overlay;
    }
    function setVerifyingOverlay(visible, text) {
        var overlay = visible ? ensureVerifyingOverlay() : document.getElementById(WHOP_VERIFYING_OVERLAY_ID);
        if (!overlay) return;
        var overlayText = overlay.querySelector(WHOP_VERIFYING_OVERLAY_TEXT_SELECTOR);
        if (overlayText && text) overlayText.textContent = text;
        overlay.classList.toggle(OVERLAY_ACTIVE_CLASS, !!visible);
    }
    function showBusy(text) {
        // Transient waits use the overlay; the line below keeps text the buyer must read.
        if (_isReturnPage || useExpressMessage()) {
            // An automatic re-render after a refused payment must not replace an error the buyer has not acted on;
            // buyer actions clear it first (clearInlineError).
            if (useExpressMessage() && _expressErrorShown) return;
            // With no wallet button on screen there is nothing for the text to refer to: the card form is hidden by
            // the template until the buyer opens it, and gets its own spinner then.
            showMessage(useExpressMessage() && !isExpressRowVisible() ? '' : text);
            return;
        }
        showMessage('');
        setVerifyingOverlay(true, text);
    }
    function isExpressRowVisible() {
        var row = find(WHOP_EXPRESS_ROW_SELECTOR);
        return !!(row && !row.hidden && row.classList.contains(WHOP_EXPRESS_ROW_VISIBLE_CLASS));
    }
    function isWhopSectionVisible() {
        var element = wrapper();
        return !!(element && element.offsetParent !== null);
    }
    function useExpressMessage() {
        // A wallet payment can run while another method is selected and the card section is hidden.
        return !_isReturnPage && isExpressActive() && !isWhopSectionVisible() && !!find(WHOP_EXPRESS_MESSAGE_SELECTOR);
    }
    function setExpressMessage(text, error) {
        var line = find(WHOP_EXPRESS_MESSAGE_SELECTOR);
        if (!line) return;
        line.textContent = text || '';
        _expressErrorShown = !!error && !!text;
        line.classList.toggle(WHOP_EXPRESS_MESSAGE_ERROR_CLASS, _expressErrorShown);
        WHOP_EXPRESS_MESSAGE_ALERT_CLASSES.forEach(function(name) { line.classList.toggle(name, _expressErrorShown); });
        line.hidden = !text;
    }
    function showMessage(text, error) {
        setVerifyingOverlay(false);
        if (useExpressMessage()) {
            // A blank update (a re-render finishing) never erases an error the buyer has not acted on yet; the card
            // path keeps its errors in the separate alert box for the same reason.
            if (text || !_expressErrorShown) setExpressMessage(text, error);
            // The buyer must be able to read an error, so it also ends the full-page processing screen.
            if (error && text) setProcessingScreen(false);
            updatePayButton();
            return;
        }
        setExpressMessage('');
        var message = find(WHOP_MESSAGE_SELECTOR);
        // Order form errors go to the alert box; the buyer cannot read them behind the processing screen.
        var inlineErrorShown = false;
        if (error && text && !_isReturnPage) {
            setProcessingScreen(false);
            inlineErrorShown = showInlineError(text);
        }
        if (message) {
            message.textContent = inlineErrorShown ? '' : (text || '');
            message.className = error && !inlineErrorShown ? ERROR_MESSAGE_CLASS : MESSAGE_CLASS;
        }
        if (_isReturnPage) {
            // Reuse the return-page spinner, revealing the message/button for errors or verification.
            var needsAttention = !!error || _paymentActionShown;
            var processing = find(WHOP_PROCESSING_SELECTOR);
            if (processing) {
                var processingText = processing.querySelector(WHOP_PROCESSING_TEXT_SELECTOR);
                if (processingText) processingText.textContent = text || '';
                processing.classList.toggle(PROCESSING_ACTIVE_CLASS, !needsAttention);
            }
            wrapper().style.display = needsAttention ? 'block' : 'none';
        }
        updatePayButton();
    }
    function freezeOrderControls(freeze) {
        if (freeze) {
            if (_frozenControls.length) return;
            var form = find(selectors.orderFormById);
            if (!form) return;
            form.querySelectorAll(FORM_CONTROLS_SELECTOR).forEach(function(control) {
                if (control.type === 'hidden' || control.matches(
                    WHOP_BUTTON_SELECTOR + ', ' + WHOP_CONTINUE_PAYMENT_SELECTOR + ', ' + WHOP_EXPRESS_BUTTON_SELECTOR
                    + ', ' + WHOP_EXPRESS_CONTINUE_SELECTOR)) return;
                _frozenControls.push({control: control, disabled: control.disabled});
                control.disabled = true;
            });
        } else {
            _frozenControls.forEach(function(item) { item.control.disabled = item.disabled; });
            _frozenControls = [];
        }
    }
    function refreshCsrf(data) {
        if (checkout.RefreshCsrfFromResponse) checkout.RefreshCsrfFromResponse(data);
    }
    function appendCsrf(data) {
        if (window.JVZoo.Security && window.JVZoo.Security.GetCsrfHash) {
            data.append(window.JVZoo.Security.GetCsrfFieldName(), window.JVZoo.Security.GetCsrfHash());
        }
    }
    async function requestJson(url, options, timeout, deferCsrfRefresh) {
        var controller = new AbortController();
        var timer = setTimeout(function() { controller.abort(); }, timeout || DEFAULT_REQUEST_TIMEOUT_MS);
        options = Object.assign({credentials: 'same-origin', cache: 'no-store',
            headers: {'Accept': 'application/json'}}, options || {}, {signal: controller.signal});
        try {
            var response = await fetch(url, options);
            var data = await response.json();
            if (!response.ok && (!data || (!data.status && typeof data.retryable !== 'boolean'))) {
                var error = new Error('Request unavailable');
                // Buyer-facing text the server sent with the refusal, such as the per-page quote limit.
                error.serverMessage = data && typeof data.message === 'string' ? data.message : '';
                throw error;
            }
            if (!deferCsrfRefresh) refreshCsrf(data);
            return data;
        } finally {
            clearTimeout(timer);
        }
    }
    function getCheckoutContextKey() {
        return _pendingContextKey || (wrapper() && wrapper().getAttribute(DATA_CHECKOUT_CONTEXT_KEY)) || '';
    }
    function preserveCheckoutContext(key) {
        _pendingContextKey = key;
        wrapper().setAttribute(DATA_CHECKOUT_CONTEXT_KEY, key);
        document.querySelectorAll(selectors.orderFormById + ' input[name="' + CHECKOUT_CONTEXT_KEY_PARAM + '"]')
            .forEach(function(field) {
                field.value = key;
            });
    }
    function storageKey() {
        return PENDING_PAYMENT_STORAGE_PREFIX + window.location.pathname + ':' + (checkout.productId || '');
    }
    function rememberPendingPayment() {
        if (_isReturnPage) return;
        // Only routing identifiers are persisted, never payment credentials.
        try {
            window.sessionStorage.setItem(storageKey(), JSON.stringify({
                checkoutContextKey: getCheckoutContextKey(), jvzooCheckoutKey: _jvzooCheckoutKey,
                registrationKey: _registrationKey, sessionKey: _sessionKey
            }));
        } catch (_) {}
    }
    function forgetPendingPayment() {
        try {
            var storage = window.sessionStorage;
            if (!_isReturnPage) storage.removeItem(storageKey());
            else for (var index = storage.length - 1; index >= 0; index--) {
                var key = storage.key(index);
                if (!key || key.indexOf(PENDING_PAYMENT_STORAGE_PREFIX) !== 0) continue;
                var pending = JSON.parse(storage.getItem(key) || 'null');
                if (pending && pending.checkoutContextKey === getCheckoutContextKey()) storage.removeItem(key);
            }
        } catch (_) {}
    }
    function restorePendingPayment() {
        var saved;
        try { saved = JSON.parse(window.sessionStorage.getItem(storageKey()) || 'null'); } catch (_) {}
        if (!saved || !saved.checkoutContextKey || !saved.jvzooCheckoutKey || !saved.registrationKey) return false;
        // Page reload creates a new context; recovery belongs to the original one.
        preserveCheckoutContext(saved.checkoutContextKey);
        _jvzooCheckoutKey = saved.jvzooCheckoutKey;
        _registrationKey = saved.registrationKey;
        _sessionKey = saved.sessionKey;
        setChargeSubmitted(true);
        freezeOrderControls(true);
        showMessage('Checking your payment. Please do not submit another payment.');
        pollPayment();
        return true;
    }
    function statusParameters() {
        var data = new URLSearchParams();
        data.append(CHECKOUT_CONTEXT_KEY_PARAM, getCheckoutContextKey());
        data.append(JVZOO_CHECKOUT_KEY_PARAM, _jvzooCheckoutKey || '');
        data.append(REGISTRATION_KEY_PARAM, _registrationKey || '');
        return data;
    }
    function stopPolling() {
        clearTimeout(_pollTimer);
        _pollTimer = null;
    }
    function schedulePoll(delay) {
        stopPolling();
        if (_pollCount >= MAX_POLL_ATTEMPTS) {
            setProcessingScreen(false);
            showMessage('Confirmation is taking longer than expected. Reload to check again; please do not pay again.', _isReturnPage);
            return;
        }
        var nextDelay = Math.min(MAX_POLL_INTERVAL_MS,
            POLL_INTERVAL_MS * Math.pow(2, Math.floor(_pollCount / POLLS_PER_BACKOFF_STEP)));
        _pollTimer = setTimeout(pollPayment, delay === undefined ? nextDelay : delay);
    }
    function setPaymentAction(secret, showAction) {
        // Every payment confirmed from a token carries a secret; only an unfinished step needs the button.
        _clientSecret = secret || null;
        _paymentActionShown = !!(_clientSecret && showAction);
        if (_paymentActionShown) setProcessingScreen(false);
        var button = find(WHOP_CONTINUE_PAYMENT_SELECTOR);
        if (button) {
            button.hidden = !_paymentActionShown;
            button.disabled = _actionInFlight;
        }
        // The button above sits in the card section; while that is hidden the buyer gets the express one instead.
        var expressButton = find(WHOP_EXPRESS_CONTINUE_SELECTOR);
        if (expressButton) {
            expressButton.hidden = !(_paymentActionShown && useExpressMessage());
            expressButton.disabled = _actionInFlight;
        }
    }
    async function presentPaymentAction() {
        if (!_clientSecret || _actionInFlight) return;
        _actionInFlight = true;
        // One automatic attempt per page load; the Continue button can still run it again.
        _actionAttempted = true;
        _lastPaymentErrorMessage = null;
        stopPolling();
        setPaymentAction(_clientSecret, _paymentActionShown);
        var needsAction = false;
        try {
            var client = await ensureElementsClient();
            var options = {clientSecret: _clientSecret};
            if (_returnUrl) options.returnUrl = _returnUrl;
            var result = await client.payments.handleNextAction(options);
            if (result && result.redirected) return;
            if (result && result.lastPaymentError && typeof result.lastPaymentError.message === 'string') {
                _lastPaymentErrorMessage = result.lastPaymentError.message;
            }
            // SDK results inform the buyer; only the server can permit another charge or fulfill the order.
            if (result && (result.status === STATUS_SUCCEEDED || result.status === STATUS_PAID)) {
                clearInlineError();
                showMessage('Verification completed. Checking your order...');
                setProcessingScreen(true, COMPLETING_ORDER_MESSAGE);
            } else if (_lastPaymentErrorMessage || (result && VERIFICATION_FAILED_STATUSES.indexOf(result.status) !== -1)) {
                showMessage((_lastPaymentErrorMessage || 'Payment verification was not completed.')
                    + ' Checking your payment before you try again.', true);
            } else if (result && result.status === STATUS_REQUIRES_ACTION) {
                // The buyer closed Whop's verification step before finishing it.
                needsAction = true;
            } else {
                showMessage('Verification is still pending. Checking your payment...');
            }
        } catch (_) {
            needsAction = true;
        } finally {
            _actionInFlight = false;
            setPaymentAction(needsAction ? _clientSecret : null, needsAction);
        }
        if (needsAction) showMessage('Please complete payment verification to continue.');
        _pollCount = 0;
        // Deferred so a poll that started this attempt has released _statusBusy before the next poll runs.
        schedulePoll(0);
    }
    function allowPaymentRetry(data, changedIdentity) {
        stopPolling();
        setPaymentAction(null);
        setProcessingScreen(false);
        if (data.status === STATUS_NOT_STARTED && data.resetContext === true) {
            // The server atomically retired this unused context, so delayed requests cannot charge it.
            forgetPendingPayment();
            _pendingContextKey = null;
            setChargeSubmitted(true);
            freezeOrderControls(true);
            if (_isReturnPage) {
                showMessage('This checkout expired without a payment. Please return to your checkout to try again.', true);
            } else {
                showMessage('Refreshing your checkout...');
                window.location.reload();
            }
            return;
        }
        // No submission yet is safe to retry only within the original context's atomic guard.
        // Keep its routing record across another reload while the original POST may still arrive.
        if (data.status === STATUS_NOT_STARTED) rememberPendingPayment();
        else forgetPendingPayment();
        if (_isReturnPage) {
            showMessage('The payment was not completed. Please return to your checkout to try again.', true);
            return;
        }
        setChargeSubmitted(false);
        // A new payment attempt may auto-run verification once again.
        _actionAttempted = false;
        var retryAfter = Number(data.retryAfter);
        _retryNotBefore = isFinite(retryAfter) && retryAfter > 0
            ? Date.now() + retryAfter * MILLISECONDS_PER_SECOND : 0;
        updateRetryCooldown();
        freezeOrderControls(false);
        if (data.sessionExpired) {
            _sessionExpired = true;
            if (checkout.Session && checkout.Session.handleResponse) checkout.Session.handleResponse(data);
        }
        if (data.refreshRequired || changedIdentity || !_whopElementsPayments) _sessionDirty = true;
        var retryMessage = data.status === STATUS_NOT_STARTED
            ? 'No payment attempt is recorded yet. Please review your order and try again.'
            : (_lastPaymentErrorMessage || data.message || 'Payment was not completed. Please review your details and try again.');
        _lastPaymentErrorMessage = null;
        showMessage(retryMessage, true);
        if (_sessionDirty && !_submitting && !isSessionLocked()) renderWhopCheckoutSession({});
    }
    async function handlePaymentResponse(data, allowAction) {
        refreshCsrf(data);
        var changedIdentity = false;
        if (data && data.jvzooCheckoutKey && data.registrationKey) {
            changedIdentity = _jvzooCheckoutKey !== data.jvzooCheckoutKey || _registrationKey !== data.registrationKey;
            _jvzooCheckoutKey = data.jvzooCheckoutKey;
            _registrationKey = data.registrationKey;
        }
        if (data && data.returnUrl) _returnUrl = data.returnUrl;
        if (_isReturnPage) updateReturnAddress();
        rememberPendingPayment();
        if (data && data.status === STATUS_COMPLETED && data.redirectUrl) {
            stopPolling();
            setPaymentAction(null);
            forgetPendingPayment();
            setProcessingScreen(true, COMPLETING_ORDER_MESSAGE);
            window.location.href = data.redirectUrl;
        } else if (data && data.status === STATUS_BLOCKED) {
            // The sale is refused for this buyer; it is final, so neither retry nor polling may resume.
            stopPolling();
            setPaymentAction(null);
            setProcessingScreen(false);
            forgetPendingPayment();
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                showMessage(data.message, true);
            }
        } else if (data && data.retryable === true) {
            allowPaymentRetry(data, changedIdentity);
        } else if (data && STOPPED_STATUSES.indexOf(data.status) !== -1) {
            // Fulfillment failure does not establish that a charge failed.
            stopPolling();
            setPaymentAction(null);
            showMessage(data.message || 'Your payment needs an order review. Please contact support before paying again.', true);
        } else if (data && (data.status === STATUS_PAID || data.status === STATUS_SUCCEEDED)) {
            _lastPaymentErrorMessage = null;
            setPaymentAction(null);
            clearInlineError();
            showMessage('Payment confirmed. Finishing your order...');
            setProcessingScreen(true, COMPLETING_ORDER_MESSAGE);
            schedulePoll();
        } else if (data && data.clientSecret && (allowAction || !_actionAttempted)) {
            // Whop opens its own step only when one is outstanding, and resolves at once when none is.
            // A reload or a lost create response reaches this from the status poll, once per page load.
            setPaymentAction(data.clientSecret, false);
            showBusy('Processing your payment...');
            await presentPaymentAction();
        } else if (data && data.clientSecret && (_paymentActionShown || data.status === STATUS_REQUIRES_ACTION)) {
            setPaymentAction(data.clientSecret, true);
            showMessage((_lastPaymentErrorMessage ? _lastPaymentErrorMessage + ' ' : '')
                + 'Please complete payment verification to continue.');
            schedulePoll();
        } else if (_paymentActionShown) {
            // An unresolved poll must not hide a verification step that is already offered.
            showMessage((_lastPaymentErrorMessage ? _lastPaymentErrorMessage + ' ' : '')
                + 'Please complete payment verification to continue.');
            schedulePoll();
        } else {
            setPaymentAction(null);
            showMessage(_lastPaymentErrorMessage
                ? _lastPaymentErrorMessage + ' Checking your payment. Please do not submit another payment.'
                : ((data && data.message) || 'Checking your payment. Please do not submit another payment.'), !!_lastPaymentErrorMessage);
            schedulePoll();
        }
    }
    async function pollPayment() {
        stopPolling();
        if (!_chargeSubmitted || _statusBusy || _actionInFlight) return;
        if (_pollCount++ >= MAX_POLL_ATTEMPTS) { schedulePoll(); return; }
        _statusBusy = true;
        try {
            var data = await requestJson(FINALIZATION_STATUS_CHECK_URI + '?' + statusParameters().toString());
            await handlePaymentResponse(data, false);
        } catch (_) {
            showMessage('Checking your payment. Please do not submit another payment.');
            schedulePoll();
        } finally {
            _statusBusy = false;
        }
    }

    function collectBillingDetails() {
        if (checkout.SyncContactPhoneNumberField) checkout.SyncContactPhoneNumberField();
        var details = {
            email: checkout.GetContactEmail() || '',
            name: (value(selectors.contactFirstNameById) + ' ' + value(selectors.contactLastNameById)).trim(),
            phone: value(selectors.contactPhoneById)
        };
        if (checkout.isHighAchieverSocietyTemplate) {
            details.name = (value(selectors.ccInfoCardHolderFirstNameById) + ' '
                + value(selectors.ccInfoCardHolderLastNameById)).trim() || details.name;
            details.address = {
                line1: checkout.GetBillingAddressLine1() || '', line2: checkout.GetBillingAddressLine2() || '',
                city: checkout.GetBillingAddressCity() || '', state: checkout.GetBillingAddressRegionBySelectedCountry() || '',
                postal_code: checkout.GetBillingAddressPostalCode() || '', country: checkout.GetBillingAddressCountryIso2() || ''
            };
        } else if (hideBillingDetails()) {
            var shipping = checkout.getShippingValues();
            details.name = shipping.shippingFullName || details.name;
            details.address = {line1: shipping.line1, line2: shipping.line2, city: shipping.city,
                state: shipping.regionName, postal_code: shipping.postalCode, country: shipping.countryIso2};
        }
        if (!details.name) delete details.name;
        if (!details.phone) delete details.phone;
        return details;
    }
    function appendBuyerFields(data) {
        [
            selectors.contactFirstNameById,
            selectors.contactLastNameById,
            selectors.contactPhoneById,
            selectors.shippingAddressDeliveryNameById,
            selectors.shippingAddressLine1ById,
            selectors.shippingAddressLine2ById,
            selectors.shippingAddressCityById,
            selectors.shippingAddressRegionNameById,
            selectors.shippingAddressZipById,
            selectors.shippingAddressCountryById
        ].forEach(function(selector) { appendField(data, selector); });
        [
            OPTOUT_SELECTOR,
            selectors.recurringConsentById,
            selectors.refundPolicyById,
            selectors.termsAndConditionsUrlById
        ].forEach(function(selector) { appendCheckbox(data, selector); });
    }
    function validateForm() {
        var valid = checkout.ValidateCreditCardInfoSection($(document), {
            phoneValidation: true, emailValidation: true, firstNameValidation: true, lastNameValidation: true,
            recurringConsentValidation: true, refundPolicyValidation: true, shippingValidation: false, paymentValidation: false
        });
        if (checkout.isHighAchieverSocietyTemplate) {
            [
                selectors.billingAddressLine1ById,
                selectors.billingAddressCityById,
                selectors.billingAddressCountryIso2ById,
                selectors.billingAddressUsStateIso2ById,
                selectors.billingAddressCaProvinceIso2ById,
                selectors.billingAddressRegionNameById
            ].forEach(function(selector) {
                var field = $(selector);
                if (!field.length || !field.is(':visible')) return;
                var missing = !field.val();
                field.toggleClass(INVALID_FIELD_CLASS, missing);
                if (missing) {
                    valid = false;
                    field.one('input change', function() { $(this).removeClass(INVALID_FIELD_CLASS); });
                }
            });
        }
        return valid;
    }
    async function validateBeforeCharge(details) {
        if (isSessionLocked()) {
            showMessage('Your checkout expired. Please refresh before paying.', true);
            return false;
        }
        if (checkout.isTestPurchase || checkout.isPhoneRoomCheckout) return true;
        var productIds = [
            checkout.productId
        ];
        document.querySelectorAll(ORDER_BUMP_INPUT_SELECTOR + ':checked').forEach(function(input) { productIds.push(input.value); });
        var data = new URLSearchParams();
        data.append(DUPLICATE_CHECK_EMAIL_PARAM, details.email);
        data.append(DUPLICATE_CHECK_NAME_PARAM, details.name || '');
        data.append(DUPLICATE_CHECK_PRODUCT_IDS_PARAM, productIds.filter(Boolean).join(','));
        // The abandoned cart row stored by this request takes its name and phone from these contact fields.
        [
            selectors.contactFirstNameById,
            selectors.contactLastNameById,
            selectors.contactPhoneById
        ].forEach(function(selector) { appendField(data, selector); });
        var duplicate = await requestJson(DUPLICATE_CHECK_URI + '?' + data.toString(), {}, DUPLICATE_CHECK_TIMEOUT_MS);
        if (duplicate.blockedEmailDomain) {
            showMessage('Please review your contact information.', true);
            return false;
        }
        var messages = Array.isArray(duplicate.messages) ? duplicate.messages : [];
        _hasPurchasedTrialProducts = !!duplicate.hasPurchasedTrialProducts;
        if (messages.length || _hasPurchasedTrialProducts) {
            $(DUPLICATE_PURCHASE_MODAL_LIST_SELECTOR).text(messages.join(', '));
            $(DUPLICATE_PURCHASE_MODAL_SELECTOR).modal('show');
            return false;
        }
        return true;
    }
    function isPaymentRequestCancelled(error) {
        return !!error && (error.code === PAYMENT_REQUEST_CANCELLED || error.message === PAYMENT_REQUEST_CANCELLED);
    }
    /*
     * The one charge path for the card button and the express wallet buttons. getToken() returns a promise of
     * {confirmationToken}. It is called before anything is awaited, so a wallet sheet it opens stays inside the
     * buyer's click; do not add an await above it. Wallet tokens skip the card-fields check only.
     */
    async function submitWithToken(getToken, options) {
        var source = (options && options.source) || TOKEN_SOURCE_PAYMENT_ELEMENT;
        var isExpress = source === TOKEN_SOURCE_EXPRESS;
        if (_submitting || _chargeSubmitted || isSessionLocked() || isRetryCoolingDown()) return;
        if (checkout.IsBlockedEmailDomain && checkout.IsBlockedEmailDomain(checkout.GetContactEmail() || '')) {
            showMessage('Please review your contact information.', true);
            return;
        }
        if (!validateForm()) return;
        if (_sessionDirty || _renderInProgress || _renderTimer) {
            showMessage('Updating your order. Please wait.');
            return;
        }
        if ((!isExpress && (!_whopElementsReady || !_whopElementsComplete)) || !_registrationKey || !_jvzooCheckoutKey) {
            showMessage('Please complete your payment information.', true);
            return;
        }
        _submitting = true;
        _expressSubmit = isExpress;
        _lastPaymentErrorMessage = null;
        clearInlineError();
        updatePayButton();
        var sequence = _renderSequence;
        try {
            var details = collectBillingDetails();
            // Snapshot buyer fields before freezing disables the enabled-only email selector.
            var data = new FormData();
            appendField(data, selectors.contactEmailById, details.email);
            appendBuyerFields(data);
            // Matches the field the order form would post (the last one wins) for the blacklist check; the server falls back to an IP lookup when absent.
            var customerCountry = postedOrderFormCountry();
            if (customerCountry) data.append(CUSTOMER_COUNTRY_ID_PARAM, customerCountry);
            freezeOrderControls(true);
            // This must start within the click gesture for wallet authentication.
            // A token is only a credential; server validation still precedes charging.
            var token = await getToken(details);
            if (!token || typeof token.confirmationToken !== 'string') throw new Error('Invalid token');
            showBusy('Verifying your information...');
            if (!await validateBeforeCharge(details)) return;
            if (_sessionDirty || sequence !== _renderSequence || isSessionLocked()) {
                showMessage('Your order changed. Please review the updated total before paying.', true);
                return;
            }
            data.append(CHECKOUT_CONTEXT_KEY_PARAM, getCheckoutContextKey());
            data.append(REGISTRATION_KEY_PARAM, _registrationKey);
            data.append(JVZOO_CHECKOUT_KEY_PARAM, _jvzooCheckoutKey);
            data.append(CONFIRMATION_TOKEN_PARAM, token.confirmationToken);
            appendCsrf(data);
            setChargeSubmitted(true);
            _pendingContextKey = getCheckoutContextKey();
            _pollCount = 0;
            rememberPendingPayment();
            await handlePaymentResponse(
                await requestJson(CREATE_PAYMENT_URI, {method: 'POST', body: data}, CREATE_PAYMENT_TIMEOUT_MS), true
            );
        } catch (error) {
            if (_chargeSubmitted) {
                // Lost responses never permit a second payment submission.
                showMessage('Checking your payment. Please do not submit another payment.');
                pollPayment();
            } else if (isExpress && isPaymentRequestCancelled(error)) {
                // The buyer closed the wallet sheet; nothing was charged and they may pay again.
                showMessage('');
            } else {
                showMessage('Unable to validate your order. Please review your information and try again.', true);
            }
        } finally {
            _submitting = false;
            if (!_chargeSubmitted) {
                // Paths such as the duplicate purchase modal stop without a message.
                setVerifyingOverlay(false);
                if (useExpressMessage() && !_expressErrorShown) setExpressMessage('');
                freezeOrderControls(false);
                if (_sessionDirty && !isSessionLocked()) renderWhopCheckoutSession({});
            }
            updatePayButton();
        }
    }
    function submitWhopCheckout() {
        return submitWithToken(function(details) {
            return _whopElementsPayments.createConfirmationToken({billingDetails: details});
        }, {source: TOKEN_SOURCE_PAYMENT_ELEMENT});
    }

    function hideBillingDetails() {
        var same = find(WHOP_SAME_AS_SHIPPING_SELECTOR);
        return !!(checkout.isHighAchieverSocietyTemplate || (same && same.checked));
    }
    function ensureElementsClient() {
        return new Promise(function(resolve, reject) {
            var checks = 0;
            function ready() {
                if (typeof window.WhopElements === 'function') {
                    if (!_whopElements) _whopElements = window.WhopElements({
                        environment: wrapper().getAttribute(DATA_WHOP_ENVIRONMENT) || DEFAULT_WHOP_ENVIRONMENT, skipPixel: true
                    });
                    resolve(_whopElements);
                } else if (checks++ < MAX_CLIENT_LOAD_CHECKS) setTimeout(ready, CLIENT_LOAD_CHECK_INTERVAL_MS);
                else reject(new Error('Payment form unavailable'));
            }
            ready();
        });
    }
    function finishRender(sequence, error, paymentElementOnly, errorMessage) {
        if (sequence !== _renderSequence) return;
        clearTimeout(_readyTimer);
        _renderInProgress = false;
        if (error) _whopElementsReady = false;
        else _revealRetry = false;
        // A Payment Element that is not ready leaves the wallets working; a failed quote hides them until the next
        // successful one, since they cannot pay from it.
        if (error && !paymentElementOnly) notifyExpressSessionCleared();
        if (error && isOtherMethodSelected()) {
            // The card form is not in use, so the buyer of the selected method sees no Whop message.
            updatePayButton();
            return;
        }
        if (error && paymentElementOnly && _revealRetry && isWhopSectionVisible()) {
            // The card section opened and the Payment Element still did not get ready: mount it once more from the
            // last quote before giving up. A stale quote is refreshed instead.
            _revealRetry = false;
            if (_sessionDirty && !isSessionLocked()) {
                renderWhopCheckoutSession({});
                return;
            }
            if (remountPaymentElement()) return;
        }
        if (error && paymentElementOnly && waitUntilWhopSectionVisible(sequence)) {
            // Classic and Modern Orange keep the card section hidden until the buyer opens it, and the Payment Element
            // does not get ready while hidden. Wait for it to show before treating that as a failure. The blank
            // update also ends the "Loading payment form..." text under the wallet buttons.
            showMessage('');
            return;
        }
        showMessage(error ? (errorMessage || 'Unable to load payment details. Please refresh and try again.') : '', !!error);
    }
    function waitUntilWhopSectionVisible(sequence) {
        var element = wrapper();
        if (_sectionObserver) _sectionObserver.disconnect();
        _sectionObserver = null;
        if (!element || isWhopSectionVisible() || typeof ResizeObserver !== 'function') return false;
        // A hidden section has no size, so the first size change is the section opening.
        var observer = new ResizeObserver(function() {
            if (!isWhopSectionVisible()) return;
            observer.disconnect();
            if (_sectionObserver === observer) _sectionObserver = null;
            if (sequence !== _renderSequence || _whopElementsReady || _renderInProgress) return;
            // Give the Payment Element its ready time again now that it shows; finishRender retries once after that.
            _revealRetry = true;
            clearTimeout(_readyTimer);
            _readyTimer = setTimeout(function() { finishRender(sequence, true, true); }, ELEMENT_READY_TIMEOUT_MS);
        });
        _sectionObserver = observer;
        observer.observe(element);
        return true;
    }
    function remountPaymentElement() {
        // Mounts the Payment Element again from the last successful quote: no server call, so no registration used.
        if (!_lastQuote || _renderInProgress || _submitting || _chargeSubmitted || isSessionLocked()) return false;
        var sequence = ++_renderSequence;
        _renderInProgress = true;
        showBusy('Loading payment form...');
        _readyTimer = setTimeout(function() { finishRender(sequence, true, true); }, ELEMENT_READY_TIMEOUT_MS);
        mountOrUpdateWhopElements(_lastQuote, sequence).catch(function() { finishRender(sequence, true, true); });
        return true;
    }
    function watchWhopSectionVisibility() {
        // Classic and Modern Orange open the card section without telling this module; which Continue button shows
        // depends on it (setPaymentAction), so recompute on every change.
        var element = wrapper();
        if (!element || typeof ResizeObserver !== 'function') return;
        var visible = isWhopSectionVisible();
        new ResizeObserver(function() {
            var now = isWhopSectionVisible();
            if (now === visible) return;
            visible = now;
            // Opened while the Payment Element is still loading (mounted hidden): its running ready timer may
            // re-mount it once instead of failing, whenever the section opened.
            if (now && !_whopElementsReady) _revealRetry = true;
            updatePayButton();
        }).observe(element);
    }
    function billingDetailsMode() {
        return hideBillingDetails() ? BILLING_DETAILS_HIDDEN : BILLING_DETAILS_MINIMAL;
    }
    function mountOrUpdateWhopElements(data, sequence) {
        var mode = data.isSetupMode ? MODE_SETUP : MODE_PAYMENT;
        var requiresFutureUsage = mode !== MODE_PAYMENT || data.requiresFutureUsage !== false;
        // Recreate the SDK handle when this policy changes; update() merges existing options.
        var identity = [
            data.whopCompanyKey,
            data.currency,
            mode,
            requiresFutureUsage
        ].join(':');
        var options = {accountId: data.whopCompanyKey, currency: data.currency, mode: mode};
        if (requiresFutureUsage) options.setupFutureUsage = SETUP_FUTURE_USAGE;
        if (data.returnUrl) options.returnUrl = data.returnUrl;
        if (data.paymentMethodConfiguration) options.paymentMethodConfiguration = data.paymentMethodConfiguration;
        if (mode === MODE_PAYMENT) options.amount = data.amountMinor;
        _returnUrl = data.returnUrl || null;
        if (_whopElementsPayments && identity === _whopElementsIdentity && _whopElementsReady) {
            _whopElementsPayments.update(options);
            finishRender(sequence);
            return Promise.resolve();
        }
        return ensureElementsClient().then(function(client) {
            if (sequence !== _renderSequence || _chargeSubmitted) return;
            if (_whopElementsPayments) _whopElementsPayments.destroy();
            var generation = ++_elementGeneration;
            _whopElementsIdentity = identity;
            _whopElementsReady = false;
            _whopElementsComplete = false;
            _whopElementsPayments = client.payments.create(options);
            _paymentElement = _whopElementsPayments.create(PAYMENT_ELEMENT_TYPE, {
                fields: {billingDetails: billingDetailsMode()},
                wallets: paymentElementWallets(),
                onReady: function() {
                    if (generation !== _elementGeneration) return;
                    _whopElementsReady = true;
                    finishRender(sequence);
                },
                onChange: function(event) {
                    if (generation !== _elementGeneration) return;
                    _whopElementsComplete = !!(event && event.complete);
                    updatePayButton();
                },
                onError: function() {
                    if (generation === _elementGeneration) finishRender(sequence, true, true);
                }
            });
            _paymentElement.mount(WHOP_PAYMENT_ELEMENT_SELECTOR);
            _whopElementsPayments.create(BRANDING_ELEMENT_TYPE).mount(WHOP_BRANDING_ELEMENT_SELECTOR);
        });
    }
    function money(amount) {
        if (amount === null || amount === undefined || amount === '') return '';
        if (typeof amount === 'string' && /[^0-9.\-]/.test(amount)) return amount;
        var number = parseFloat(amount);
        return isNaN(number) ? amount : _currencySymbol + number.toFixed(2);
    }
    function updatePricing(pricing) {
        if (!pricing) return;
        _currencySymbol = pricing.currencySymbol || _currencySymbol;
        setText(selectors.orderTotalByDataAttr, money(pricing.grandTotal));
        setText(selectors.productPriceByDataAttr, money(pricing.productPrice));
        setText(selectors.productDisplayPriceByDataAttr, money(pricing.productPrice));
        setText(selectors.shippingAmountByDataAttr, money(pricing.shippingAmount));
        var hasVat = parseFloat(pricing.vatRate) > 0 && pricing.vatAmount != null && pricing.totalWithVat != null;
        show(VAT_INFO_SELECTOR, hasVat);
        if (hasVat) {
            setText(VAT_AMOUNT_SELECTOR, money(pricing.vatAmount));
            setText(TOTAL_WITH_VAT_SELECTOR, money(pricing.totalWithVat));
        }
        if (pricing.recurringPaymentDescription != null) {
            document.querySelectorAll(RECURRING_CONSENT_TEXT_SELECTOR).forEach(function(element) {
                element.innerHTML = pricing.recurringPaymentDescription;
            });
        }
        if (pricing.couponValid != null) {
            var valid = !!pricing.couponValid;
            var validated = find(selectors.couponValidatedById);
            if (validated) validated.value = valid ? FIELD_CHECKED_VALUE : FIELD_UNCHECKED_VALUE;
            show(selectors.applyCouponById, !valid, 'inline-block');
            show(selectors.removeCouponById, valid, 'inline-block');
            setText(COUPON_ERROR_SELECTOR, valid ? '' : (pricing.couponMessage || ''));
            show(COUPON_ERROR_SELECTOR, !valid && !!pricing.couponMessage);
            var discounted = valid && parseFloat(pricing.couponDiscount) > 0;
            show(COUPON_DISCOUNT_ROW_SELECTOR, discounted, 'flex');
            setText(COUPON_DISCOUNT_VALUE_SELECTOR, discounted ? '-' + money(pricing.couponDiscount) : '');
            setText(COUPON_LABEL_SELECTOR, discounted && pricing.couponDiscountPercentage ? pricing.couponDiscountPercentage + '% OFF' : '');
            var normally = find(NORMALLY_PRICE_ROW_SELECTOR);
            if (normally) show(NORMALLY_PRICE_ROW_SELECTOR, discounted || normally.getAttribute(DATA_HAS_TRIAL) === FIELD_CHECKED_VALUE, 'flex');
            show(CART_SUMMARY_TITLE_SELECTOR, !discounted);
        }
        Object.keys(pricing.bumpPrices || {}).forEach(function(id) {
            setText(ORDER_BUMP_SUMMARY_ROW_SELECTOR + '[' + DATA_ORDER_BUMP_ID + '="' + id + '"] ' + ORDER_BUMP_SUMMARY_PRICE_SELECTOR,
                money(pricing.bumpPrices[id]));
            var input = find(ORDER_BUMPS_SELECTOR + ' ' + ORDER_BUMP_INPUT_SELECTOR + '[value="' + id + '"]');
            var item = input && input.closest(ORDER_BUMP_ITEM_SELECTOR);
            if (!item) return;
            var price = item.querySelector(ORDER_BUMP_PRICE_SELECTOR);
            if (price) price.textContent = money(pricing.bumpPrices[id]);
            var recurring = item.querySelector(ORDER_BUMP_RECURRING_SELECTOR);
            if (recurring && pricing.bumpRecurringDescriptions && pricing.bumpRecurringDescriptions[id]) {
                recurring.innerHTML = pricing.bumpRecurringDescriptions[id];
            }
        });
    }
    async function renderWhopCheckoutSession(options) {
        if (_submitting || _chargeSubmitted || isSessionLocked() || !wrapper()) return null;
        options = options || {};
        clearTimeout(_renderTimer);
        clearTimeout(_readyTimer);
        _renderTimer = null;
        var sequence = ++_renderSequence;
        // With another method selected the quote only feeds the express wallets: no page pricing, busy state or errors.
        var forExpressOnly = isOtherMethodSelected();
        if (forExpressOnly) _otherMethodQuotes++;
        _renderInProgress = true;
        _sessionDirty = true;
        if (!forExpressOnly) showBusy(_sessionKey ? 'Updating checkout...' : 'Loading payment form...');
        var data = new FormData();
        data.append(CHECKOUT_CONTEXT_KEY_PARAM, getCheckoutContextKey());
        data.append(USE_ELEMENTS_PARAM, FIELD_CHECKED_VALUE);
        appendBuyerFields(data);
        var country = find(selectors.shippingAddressCountryById);
        if (options.shippingCountryId && country && country.name) data.set(country.name, options.shippingCountryId);
        var coupon = options.couponCode || value(selectors.couponCodeById);
        var validated = value(selectors.couponValidatedById) === FIELD_CHECKED_VALUE;
        if (options.couponAction === 'remove' || _couponRemoved) {
            appendField(data, selectors.removeCouponById, FIELD_CHECKED_VALUE);
        } else if (coupon && (options.couponAction === 'apply' || validated)) {
            appendField(data, selectors.couponCodeById, coupon);
            appendField(data, selectors.applyCouponById, FIELD_CHECKED_VALUE);
        }
        document.querySelectorAll(ORDER_BUMP_INPUT_SELECTOR + ':checked').forEach(function(input) { data.append(input.name, input.value); });
        appendCsrf(data);
        try {
            var result = await requestJson(RENDER_CHECKOUT_SESSION_URI, {method: 'POST', body: data}, DEFAULT_REQUEST_TIMEOUT_MS, true);
            if (sequence !== _renderSequence || _chargeSubmitted) return null;
            // The buyer may have switched to another method while this quote was in flight.
            if (!forExpressOnly && isOtherMethodSelected()) forExpressOnly = true;
            refreshCsrf(result);
            if (forExpressOnly) _deferredWhopPricing = result.pricing || null;
            else {
                _deferredWhopPricing = null;
                updatePricing(result.pricing);
            }
            if (result.sessionExpired) {
                _sessionExpired = true;
                if (checkout.Session && checkout.Session.handleResponse) checkout.Session.handleResponse(result);
            }
            if (!result.success || isSessionLocked()) {
                _renderInProgress = false;
                if (forExpressOnly && !isSessionLocked()) {
                    // A wallet payment cannot go through on this quote (e.g. below Whop's minimum); hide the wallets.
                    notifyExpressSessionCleared();
                    updatePayButton();
                    return result;
                }
                // The wallets cannot pay from a refused quote either; the next successful one shows them again.
                notifyExpressSessionCleared();
                showMessage(result.message || 'Unable to update checkout. Please review your order.', true);
                return result;
            }
            if (!result.whopCompanyKey || !result.currency || !result.jvzooCheckoutKey || !result.registrationKey
                || !result.sessionKey || (!result.isSetupMode && !(result.amountMinor > 0))) throw new Error('Incomplete quote');
            _sessionKey = result.sessionKey;
            _jvzooCheckoutKey = result.jvzooCheckoutKey;
            _registrationKey = result.registrationKey;
            var field = find(WHOP_SESSION_FIELD_SELECTOR);
            if (field) field.value = _sessionKey;
            wrapper().setAttribute(DATA_JVZOO_CHECKOUT_KEY, _jvzooCheckoutKey);
            _sessionDirty = false;
            _lastQuote = result;
            _readyTimer = setTimeout(function() { finishRender(sequence, true, true); }, ELEMENT_READY_TIMEOUT_MS);
            await mountOrUpdateWhopElements(result, sequence);
            if (sequence === _renderSequence) notifyExpressSession(result);
            if (sequence === _renderSequence && checkout.Session && checkout.Session.startTimer) checkout.Session.startTimer();
            return result;
        } catch (error) {
            if (sequence === _renderSequence) {
                _sessionDirty = true;
                finishRender(sequence, true, false, error && error.serverMessage);
            }
            return null;
        }
    }
    function scheduleRender() {
        if (_chargeSubmitted) return;
        _sessionDirty = true;
        clearInlineError();
        updatePayButton();
        if (_submitting) return;
        if (isOtherMethodSelected() && !canQuoteForExpress()) {
            if (isExpressActive()) pauseExpressForOtherMethod();
            return;
        }
        clearTimeout(_renderTimer);
        _renderTimer = setTimeout(function() { _renderTimer = null; renderWhopCheckoutSession({}); }, RENDER_DEBOUNCE_MS);
    }
    function bindOrderChanges() {
        var country = find(selectors.shippingAddressCountryById);
        if (country) country.addEventListener('change', scheduleRender);
        var bumps = document.querySelectorAll(ORDER_BUMP_INPUT_SELECTOR);
        if (bumps.length) {
            checkout.setUsesCustomOrderBumpHandler(checkout.getIsUsingWhop());
            bumps.forEach(function(input) { input.addEventListener('change', scheduleRender); });
        }
        var apply = find(selectors.applyCouponById);
        if (apply && apply.type === 'button') apply.addEventListener('click', function(event) {
            if (checkout.getIsUsingWhop && !checkout.getIsUsingWhop()) {
                _couponRemoved = false;
                // The selected processor applies the coupon itself; the express wallets still need a Whop quote with it.
                if (_submitting || _chargeSubmitted || !value(selectors.couponCodeById)) return;
                if (canQuoteForExpress()) {
                    renderWhopCheckoutSession({couponCode: value(selectors.couponCodeById), couponAction: 'apply'});
                } else if (isExpressActive()) {
                    pauseExpressForOtherMethod();
                }
                return;
            }
            event.preventDefault();
            if (_submitting || _chargeSubmitted || !value(selectors.couponCodeById)) return;
            _couponRemoved = false;
            clearInlineError();
            renderWhopCheckoutSession({couponCode: value(selectors.couponCodeById), couponAction: 'apply'});
        });
        var remove = find(selectors.removeCouponById);
        if (remove && remove.type === 'button') remove.addEventListener('click', function(event) {
            if (checkout.getIsUsingWhop && !checkout.getIsUsingWhop()) {
                _couponRemoved = true;
                if (_submitting || _chargeSubmitted) return;
                if (canQuoteForExpress()) renderWhopCheckoutSession({couponAction: 'remove'});
                else if (isExpressActive()) pauseExpressForOtherMethod();
                return;
            }
            event.preventDefault();
            if (_submitting || _chargeSubmitted) return;
            var input = find(selectors.couponCodeById);
            if (input) input.value = '';
            _couponRemoved = true;
            clearInlineError();
            renderWhopCheckoutSession({couponAction: 'remove'});
        });
        var same = find(WHOP_SAME_AS_SHIPPING_SELECTOR);
        if (same) same.addEventListener('change', function() {
            if (_paymentElement) _paymentElement.update({fields: {billingDetails: billingDetailsMode()}});
        });
    }

    // Preserve the page's existing initialization and refresh entry points.
    whopCheckout.onPaymentMethodChange = function(usingWhop) {
        if (!_initialized || _chargeSubmitted || _submitting) return;
        checkout.setUsesCustomOrderBumpHandler(!!usingWhop && document.querySelectorAll(ORDER_BUMP_INPUT_SELECTOR).length > 0);
        // A message from a wallet payment made while another method was selected belongs to that state.
        if (usingWhop && !isSessionLocked()) setExpressMessage('');
        if (usingWhop && _deferredWhopPricing && !_sessionDirty && !_renderInProgress) {
            // The page shows the other method's prices; the Whop session is current, so show its quote again.
            updatePricing(_deferredWhopPricing);
            _deferredWhopPricing = null;
        }
        if (!usingWhop && canQuoteForExpress()) {
            // The express wallets keep paying from this session; order changes keep repricing it (scheduleRender).
            updatePayButton();
        } else if (!usingWhop) {
            // Other processors can update this same order form. Ignore outstanding
            // Whop quotes and request a fresh one if the buyer returns to Whop.
            pauseExpressForOtherMethod();
        } else if (_sessionDirty || (_sessionKey && !_whopElementsReady && !_renderInProgress)) {
            // Also when the Payment Element did not become ready while its section was hidden. Only once a quote
            // exists: applyBindings selects Whop before its own first quote, which must stay the only one.
            _deferredWhopPricing = null;
            renderWhopCheckoutSession({});
        }
    };
    whopCheckout.setConfiguration = function(planKey, sessionKey) { _sessionKey = sessionKey || null; };
    whopCheckout.renderWhopIframe = renderWhopCheckoutSession;
    // Bridge for jvzoo.checkout.whop.express.js: it shares this Whop client and hands its wallet token to the one charge path.
    whopCheckout.getElementsClient = ensureElementsClient;
    whopCheckout.submitWithToken = function(getToken) {
        return submitWithToken(getToken, {source: TOKEN_SOURCE_EXPRESS});
    };
    whopCheckout.setExpressWallets = function(types, availableTypes) {
        var applePayBefore = paymentElementWallets().applePay;
        _expressWallets = Array.isArray(types) ? types.slice() : [];
        if (Array.isArray(availableTypes)) _expressAvailableWallets = availableTypes.slice();
        if (_paymentElement && paymentElementWallets().applePay !== applePayBefore) {
            try {
                _paymentElement.update({wallets: paymentElementWallets()});
            } catch (_) {
                // Never let this stop the express row from showing; the Payment Element keeps its earlier wallets.
            }
        }
    };
    whopCheckout.applyBindings = function() {
        if (_initialized || !wrapper()) return;
        _initialized = true;
        // The duplicate purchase modal sits inside the Whop card section, which is hidden while another payment
        // method is selected; a wallet payment can still need it, so it lives at page level.
        // Only with the express row on the page, so turning the button off leaves the page as it was.
        if (find(WHOP_EXPRESS_ROW_SELECTOR)) {
            var duplicateModal = find(DUPLICATE_PURCHASE_MODAL_SELECTOR);
            if (duplicateModal && duplicateModal.parentNode !== document.body) document.body.appendChild(duplicateModal);
            // Same for the full-page processing screen (a fixed overlay, so the card path looks the same).
            var processingScreen = find(WHOP_PROCESSING_SELECTOR);
            if (processingScreen && processingScreen.parentNode !== document.body) document.body.appendChild(processingScreen);
        }
        checkout.setIsWhopToggle(true);
        checkout.setIsUsingWhop(true);
        if (checkout.Session) checkout.Session.init({
            enabled: wrapper().getAttribute(DATA_SESSION_EXPIRY_ENABLED) !== FIELD_UNCHECKED_VALUE,
            expiryDurationDays: parseFloat(wrapper().getAttribute(DATA_SESSION_EXPIRY_DAYS)) || undefined,
            onLock: function() { showMessage(checkout.Session.SESSION_EXPIRY_MESSAGE, true); }
        });
        var total = find(selectors.orderTotalByDataAttr);
        if (total) _currencySymbol = total.textContent.replace(/[0-9.,\s]/g, '') || '$';
        bindOrderChanges();
        watchWhopSectionVisibility();
        var action = find(WHOP_CONTINUE_PAYMENT_SELECTOR);
        if (action) action.addEventListener('click', presentPaymentAction);
        var expressAction = find(WHOP_EXPRESS_CONTINUE_SELECTOR);
        if (expressAction) expressAction.addEventListener('click', presentPaymentAction);
        updatePayButton();
        if (!restorePendingPayment()) renderWhopCheckoutSession({});
    };
    function updateReturnAddress() {
        // Provider return parameters never establish success or remain in the address bar.
        var params = new URLSearchParams();
        params.append(CHECKOUT_CONTEXT_KEY_PARAM, getCheckoutContextKey());
        params.append(REGISTRATION_KEY_PARAM, _registrationKey);
        params.append(JVZOO_CHECKOUT_KEY_PARAM, _jvzooCheckoutKey);
        window.history.replaceState(null, '', window.location.pathname + '?' + params.toString());
        _returnUrl = window.location.href;
    }
    if (_isReturnPage) {
        _pendingContextKey = wrapper().getAttribute(DATA_CHECKOUT_CONTEXT_KEY);
        _jvzooCheckoutKey = wrapper().getAttribute(DATA_JVZOO_CHECKOUT_KEY);
        _registrationKey = wrapper().getAttribute(DATA_REGISTRATION_KEY);
        setChargeSubmitted(true);
        updateReturnAddress();
        find(WHOP_CONTINUE_PAYMENT_SELECTOR).addEventListener('click', presentPaymentAction);
        pollPayment();
        return;
    }
    document.addEventListener('click', function(event) {
        if (event.target.closest(WHOP_BUTTON_SELECTOR)) {
            event.preventDefault();
            submitWhopCheckout();
        }
    });
    $(DUPLICATE_PURCHASE_MODAL_SELECTOR).on('hidden.bs.modal', function() {
        if (_hasPurchasedTrialProducts && checkout.customerPurchasesUrl) window.location.href = checkout.customerPurchasesUrl;
    });
    $(window).on('beforeunload', stopPolling);
    $(document).ready(whopCheckout.applyBindings);
})(window, window.jQuery);
